import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './Tooltip.module.css';

type Props = PropsWithChildren<{
  className?: string;
}>;

const Tooltip = ({ className, children }: Props): JSX.Element => (
  <span className={cn(styles.tooltip, className)}>
    <span className={styles.tooltip__message}>{children}</span>
  </span>
);

export default Tooltip;
